
import {
  defineComponent,
} from 'vue';

export default defineComponent({
  props: {
    align: {
      type: String,
      required: false,
      default: () => 'right',
    },
  },
});
